import { Component } from 'react'
import RecentArticles from '../../../Utilities/RecentArticles'

class EmbedRecentArticles extends Component {
    render() {
        return (<RecentArticles embedded />)
    }
}

export default EmbedRecentArticles